export enum ShiftEvent {
  Workday = "WORK_DAY",
  TemporaryWorkday = "TEMPORARY_WORK_DAY",
  Restday = "REST_DAY",
}
